import React from 'react'
import HelpText from '../../HelpText'

const FEEHelpButton = props => {
  return props.ineligibleForFEEHelpInd === 'Y' ? null : (
    <div className="question-group question-group-divider">
      <HelpText tag="h3" text="You are eligible for a FEE-HELP Loan." />

      <div className="financial-content">
        <p>This means you can apply for a loan from the Australian Government to pay all your VU study fees.</p>
        <p>
          If you wish to apply for a FEE-HELP loan, please note: you will need to include your Tax File Number (TFN) and Unique Student Identifier (USI) when completing the electronic
          Commonwealth Assistance Form (eCAF), which must be done before your first enrolled census date.
        </p>

        <HelpText tag="h3" text="How would you prefer to pay your fees?" />
        <p>
          Apply for a FEE-HELP loan here
          <a className={`btn btn-financial-margin btn-financial-small btn-primary center ${props.isHelpSubmitted === 'Y' ? 'disabled-link' : ''}`} href={props.link}>
            Apply
          </a>
        </p>
        <p>Or pay your fees by the due date.</p>
      </div>
    </div>
  )
}

export default FEEHelpButton
